import { faBlog, faLayerGroup } from "@fortawesome/free-solid-svg-icons";
import { PageConfigs } from "configs/globalInterfaces";

const name = "blogCategories";

export const CONFIGS: PageConfigs = {
  title: name,
  path: `/${name}`,
  icon: faBlog,
  apiName: `${name}`,
  routeName: name,
  apiAddress: `${"blog-categories"}`,
  componentNames: ["blogCategory", "blogCategories"],
  permissions: [`read:${name}`, `maintain:${name}`],
  routes: {
    all: `/${name}/*`,
    base: `/${name}`,
    list: "/list",
    add: `/add`,
    edit: `/edit/:id`,
  },
};
